import {api} from '../../api';
import {createMutation} from '../../lib';

interface PostBillingTariffsParams {
  companyId: string;
  tariffId: number;
  durationId: number;
}

const postBillingTariffs = (params: PostBillingTariffsParams) => {
  return api.billing.postBillingTariffs(params);
};

export const usePostBillingTariffsMutation = createMutation(postBillingTariffs);
